import {gql} from 'apollo-angular';

export const GET_ROOKIE_SCHOOL_CLASSES = gql`
  query GetRookieSchoolClasses($schoolId: Int!) {
    rookieSchoolClasses(schoolId: $schoolId) {
      schoolId
      schoolClassId
      schoolClassName
    }
  }
`;
